module.exports = __webpack_public_path__ + "static/assets/2f78cb5bccaeadd70f6b271c2d22b399.svg";